var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m1156.2 2807.9 643.84-643.84 643.84 643.84c18.566 18.598 43.426 28.469 68.727 28.469 12.496 0 25.145-2.4023 37.16-7.4023 36.316-15.031 59.973-50.449 59.973-89.77v-1878.5c0-53.672-43.492-97.164-97.164-97.164h-1425.1c-53.672 0-97.164 43.492-97.164 97.164v1878.5c0 39.312 23.656 74.738 59.969 89.758 36.375 15.152 78.188 6.7461 105.89-21.055zm28.469-1850h1230.7v1546.8l-546.67-546.67c-18.98-18.98-43.84-28.469-68.695-28.469s-49.723 9.4883-68.695 28.469l-546.67 546.67z",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.ecbf9231dee853750de0bb0d5f49e35d.svg";
export { ForwardRef as ReactComponent };